import api from 'utils/api';
import { PLATFORM_ORG_ID } from './../domains/orgDomain';
import {
  BaseSvcCreateParams,
  Svc,
  SvcSpec,
  SvcSpecCreateParams,
  SvcSpecUpdateParams,
  SvcType,
  SvcUpdateParams,
} from './../domains/svcDomain';

const svcService = {
  getAllSVCs: async () => {
    return api.post<Svc[]>(`/api/services/list/all`);
  },

  getAllBaseSVCs: async () => {
    return api.post<Svc[]>(`/api/services/list/all`, undefined, {
      'X-Tenant-ID': PLATFORM_ORG_ID,
    });
  },

  createBaseSvc: async (params: BaseSvcCreateParams) => {
    return api.post<Svc>(`/api/services/createBase`, {
      ...params,
    });
  },

  createOrgSvc: async (baseSvcId: number) => {
    return api.post<Svc>(`/api/services/createOrg?baseSvcId=${baseSvcId}`);
  },

  updateSVC: async (params: SvcUpdateParams) => {
    return api.put<Svc>(`/api/services/${params.id}`, {
      ...params,
    });
  },

  deleteSVC: async (svcId: number) => {
    return api.delete(`/api/services/${svcId}`);
  },

  getSVCTypes: async () => {
    return api.post<SvcType[]>(`/api/service-types/list/all`);
  },

  createBaseSpec: async (params: SvcSpecCreateParams) => {
    return api.post<SvcSpec>(`/api/services/specs/createBase`, params);
  },

  updateSpec: async (params: SvcSpecUpdateParams) => {
    return api.put<SvcSpec>(`/api/services/specs/${params.id}`, {
      ...params,
    });
  },

  addSpec: async (baseSpecId: number, orgSvcId: number) => {
    return api.post<SvcSpec>(
      `/api/services/specs/add?baseSpecId=${baseSpecId}&orgSvcId=${orgSvcId}`
    );
  },

  deleteSpec: async (specId: number) => {
    return api.delete(`/api/services/specs/${specId}`);
  },

  getSvcTree: async () => {
    return api.get(`/api/services/base-tree`);
  },
};

export default svcService;
